import { RefObject, useEffect } from "react";
import { ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED } from "@/constants/constants.ts";
import { hasExtendedWarranties } from "@/components/AddToBasket/utils/utils.ts";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { Product } from "@/types/types.ts";

export const useScrollToButton = (
  product: Product,
  addToBasketRef: RefObject<HTMLDivElement | null>,
) => {
  const { variant } = useVariant(product);

  const appleProduct = product?.brand?.name.toLowerCase() === "apple";
  const variantHasExtendedWarranties = hasExtendedWarranties(variant?.services);
  const shouldScrollToA2B = appleProduct || variantHasExtendedWarranties;

  useEffect(() => {
    const scrollToAddToBasketButton = () => {
      if (addToBasketRef.current) {
        const scrollOptions: ScrollIntoViewOptions = {};
        if (!window.matchMedia("(prefers-reduced-motion)").matches) {
          scrollOptions.behavior = "smooth";
        }

        const scrollIntoView = () =>
          addToBasketRef.current?.scrollIntoView(scrollOptions);
        setTimeout(scrollIntoView, 0);
      }
    };

    if (shouldScrollToA2B) {
      window.addEventListener(
        ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED,
        scrollToAddToBasketButton,
      );
    }

    return () => {
      if (shouldScrollToA2B) {
        window.removeEventListener(
          ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED,
          scrollToAddToBasketButton,
        );
      }
    };
  }, [shouldScrollToA2B]);
};
